import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { FALLBACK_LANG, LANGUAGES, LOCAL_STORAGE_LANGUAGE } from 'src/i18n/constants';
import { APP_BUILD_VERSION } from 'src/config-global';

import { syncDocumentLanguage } from './document-language';

const COMMON_NAMESPACES = ['translation'];

syncDocumentLanguage(i18n);

i18n
  .use(LanguageDetector)
  .use(
    resourcesToBackend((language: string, namespace: string) => {
      let path = `/src/views/${namespace}/locales/${language}.json`;

      if (COMMON_NAMESPACES.includes(namespace)) {
        path = `/src/i18n/common-locales/${language}.json`;
      }

      const url = `${path}?v=${APP_BUILD_VERSION}`;

      return fetch(url)
        .then((response) => response.json())
        .catch((err) => {
          console.error(`Error loading ${path}:`, err);
          return {};
        });
    })
  )
  .use(initReactI18next)
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // debug: process.env.NODE_ENV === 'development',
    debug: false,
    ns: [],
    fallbackLng: FALLBACK_LANG,
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    supportedLngs: LANGUAGES,
    load: 'currentOnly',
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: LOCAL_STORAGE_LANGUAGE,
    },
  });

export default i18n;
